import { IControlProperties } from '../../../../../../../entities';
import { IDataGridColumn } from '../../../entities';

export const orderColumns = (
	a: IDataGridColumn<IControlProperties>,
	b: IDataGridColumn<IControlProperties>
) => {
	if (a.editType === 'actionButton' && b.editType !== 'actionButton') {
		return -1;
	} else if (a.editType !== 'actionButton' && b.editType === 'actionButton') {
		return 1;
	}

	return 0;
};
